import React from 'react';
import { Helmet } from 'react-helmet';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Meta page component.
 *
 * @author Mikhail Siutsou
 * @function MetaPage
 * @category components
 * @param {MetaPageProps['title']} title page.
 * @param {MetaPageProps['description']} description page.
 * @param {MetaPageProps['keywords']} keywords page.
 * @return {FC} Meta page component.
 */
var MetaPage = function MetaPage(_ref) {
  var title = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords;
  return /*#__PURE__*/_jsxs(Helmet, {
    defaultTitle: "Wisper admin",
    children: [title && /*#__PURE__*/_jsxs("title", {
      children: ["Wisper admin", title && ": ".concat(title)]
    }), description && /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: description
    }), keywords && /*#__PURE__*/_jsx("meta", {
      name: "keywords",
      content: keywords
    })]
  });
};

export { MetaPage };